import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta:{
      title:"首页"
    },
  },{
    path: "/jiagong",
    name: "jiagong",
    meta:{
      title:"加工"
    },
    component: () =>
      import( "../views/Jiagong.vue"),
  },{
    path: "/chejian",
    name: "chejian",
    meta:{
      title:"车间"
    },
    component: () =>
      import( "../views/Chejian.vue"),
  },{
    path: "/kshyqjk",
    name: "kshyqjk",
    meta:{
      title:"园区监控"
    },
    component: () =>
      import( "../views/kshyqjk.vue"),
  },{
    path: "/xiaofei",
    name: "xiaofei",
    meta:{
      title:"消费-电商直播"
    },
    component: () =>
      import( "../views/Xiaofei.vue"),
  },{
    path: "/xiaofeiChanpin",
    name: "xiaofeiChanpin",
    meta:{
      title:"消费-电商产品"
    },
    component: () =>
      import( "../views/XiaofeiChanpin.vue"),
  },{
    path: "/xiaofeiData",
    name: "xiaofeiData",
    meta:{
      title:"消费-电商大数据"
    },
    component: () =>
      import( "../views/XiaofeiData.vue"),
  },{
    path: "/zhibo",
    name: "zhibo",
    meta:{
      title:"消费-电商直播看板"
    },
    component: () =>
      import( "../views/Zhibo.vue"),
  },{
    path: "/xfksh",
    name: "xfksh",
    meta:{
      title:"消费-可视化监控"
    },
    component: () =>
      import( "../views/xfksh.vue"),
  },{
    path: "/plant",
    name: "plant",
    meta:{
      title:"高标准农田"
    },
    component: () =>
      import( "../views/Plant.vue"),
  },{
    path: "/gbzntjs",
    name: "gbzntjs",
    meta:{
      title:"项目进度"
    },
    component: () =>
      import( "../views/gbzntjs.vue"),
  },{
    path: "/gbzntyj",
    name: "gbzntyj",
    meta:{
      title:"运营状态"
    },
    component: () =>
      import( "../views/gbzntyj.vue"),
  },{
    path: "/zuowufenxi",
    name: "zuowufenxi",
    meta:{
      title:"作物分析"
    },
    component: () =>
      import( "../views/Zuowufenxi.vue"),
  },{
    path: "/zhinengGG",
    name: "zhinengGG",
    meta:{
      title:"智能灌溉"
    },
    component: () =>
      import( "../views/ZhinengGG.vue"),
  },{
    path: "/binghai",
    name: "binghai",
    meta:{
      title:"病虫害管理"
    },
    component: () =>
      import( "../views/Binghai.vue"),
  },{
    path: "/plantmoxing",
    name: "plantmoxing",
    meta:{
      title:"种植模型"
    },
    component: () =>
      import( "../views/Plantmoxing.vue"),
  },{
    path: "/suyuan",
    name: "suyuan",
    meta:{
      title:"农业溯源"
    },
    component: () =>
      import( "../views/Sunyuan.vue"),
  },{
    path: "/qihouYj",
    name: "qihouYj",
    meta:{
      title:"气候灾害预警"
    },
    component: () =>
      import( "../views/QihouYj.vue"),
  },{
    path: "/xmditu",
    name: "xmditu",
    meta:{
      title:"项目地图"
    },
    component: () =>
      import( "../views/Xmditu.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
